import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CustomersService } from '../shared/customers.service';
import { Customer } from '../shared/customer';
import { Location } from '@angular/common';
import { MessageService } from '../../../core/services/message.service';
import { OpenStreetMapService } from '../../map/services/open-street-map.service';
import { AddressControlComponent } from 'src/app/shared/address-control/address-control.component';

@Component({
  selector: 'app-customers-add',
  templateUrl: './customers-add.component.html',
  styleUrls: ['./customers-add.component.css']
})
export class CustomersAddComponent implements OnInit {
  form: FormGroup;
  submitted: boolean;
  id: any;
  client: Customer;
  isEditing: boolean;
  submitButtonText: string = 'GENERAL.LABELS.SAVE';
  titleText: string = 'CUSTOMERS.ADD';
  mark1: any;
  addressOption: number = 0;
  @ViewChild("addressControl") addressControl: AddressControlComponent;

  constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private service: CustomersService,
    private messageService: MessageService, private location: Location, private openStreetMapService: OpenStreetMapService) {
    this.id = this.activatedRoute.snapshot.params['id'];
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      lastName: ['', Validators.required],
      secondLastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      telephone: ['', [Validators.required, Validators.minLength(6)]]
    });

    if (this.id) {
      this.isEditing = true;
      this.submitButtonText = "GENERAL.LABELS.EDIT";
      this.titleText = "CUSTOMERS.EDIT"

      this.service.get(this.id).subscribe((data: any) => {
        this.client = data.data;
        this.form = this.formBuilder.group({
          name: [this.client.name, Validators.required],
          lastName: [this.client.lastName, Validators.required],
          secondLastName: [this.client.secondLastName, Validators.required],
          email: [this.client.email, [Validators.required, Validators.email]],
          telephone: [this.client.telephone, [Validators.required, Validators.minLength(6)]]
        });
        this.addressControl.setAddressData(this.client);
        this.addressControl.setLatLong(this.client.lat, this.client.long);
      });
    }
  }

  // convenience getter for easy access to form fields
  get controls() {
    return this.form.controls;
  }

  onSubmit() {
    this.submitted = true;

    let addressControlData = this.addressControl.getAddressData();

    if (this.form.invalid || addressControlData.isInvalid) {
      return;
    }

    let customer: Customer = this.form.value as Customer;
    let address: Customer = addressControlData.values as Customer;
    debugger;
    let model = Object.assign({}, customer, address);
    if (this.isEditing) {
      //Call service sending entity to edit
      model.id = this.id;
      this.service.update(model).subscribe(() => {
        this.messageService.success('GENERAL.MESSAGE.TITLE_SUCCESS', 'GENERAL.MESSAGE.SUCCESS',
            {
              article: 'GENERAL.MESSAGE.THE_1',
              function: 'CUSTOMERS.SINGLE',
              action: 'GENERAL.MESSAGE.ACTIONS.ACTION_UPDATE'
            });

        this.back();
      }, error => {
        this.messageService.handleError(error);
      });
    }
    else {
      //Call service sending entity to add
      this.service.save(model).subscribe(() => {
        this.messageService.success('GENERAL.MESSAGE.TITLE_SUCCESS', 'GENERAL.MESSAGE.SUCCESS',
        {
          article: 'GENERAL.MESSAGE.THE_1',
          function: 'CUSTOMERS.SINGLE',
          action: 'GENERAL.MESSAGE.ACTIONS.ACTION_ADD'
        });
        this.back();
      }, error => {
        this.messageService.handleError(error);
      });
    }
  }

  getStartMark() {
    return this.mark1;
  }
  getEndMark() {
    return this.mark1;
  }

  back() {
    this.location.back();
  }

  resetForm() {
    this.form.reset();
    this.submitted = false;
    this.addressControl.clearControls();
  }

}
